import { LocationTabWrapper, LocationTabItem } from './LocationTab.styled'
import { useState, useEffect } from 'react'
import { LAYOUT_TEMPLATE } from '../../services/api/types'
import { useRouter } from 'next/router'
import {
  formatStateForUrl,
  getStateFromGymsPath
} from '../../services/gymStateUrl'

export interface LocationTabProps {
  tabItems?: Array<string>
  selectedTab?: string
  tabClick?: Function
  template?: LAYOUT_TEMPLATE
  usePathBasedFilter?: boolean
  filterBasePath?: string
}

export const LocationTab = (props: LocationTabProps) => {
  const {
    tabItems,
    tabClick,
    selectedTab,
    template,
    usePathBasedFilter,
    filterBasePath
  } = props
  const [selectTab, setSelectTab] = useState(selectedTab)
  const router = useRouter()

  useEffect(() => {
    if (usePathBasedFilter && filterBasePath) {
      const hash = window.location.hash.replace('#', '')
      if (hash) {
        window.history.replaceState(
          null,
          '',
          `${filterBasePath}/${hash.toLowerCase()}`
        )
        return
      }

      const stateFromPath = getStateFromGymsPath(
        window.location.pathname,
        tabItems
      )
      if (
        stateFromPath &&
        stateFromPath.toLowerCase() !== selectedTab?.toLowerCase()
      ) {
        setSelectTab(stateFromPath)
        setTimeout(() => {
          tabClick && tabClick(stateFromPath)
        }, 100)
      }
      return
    }

    const hash = window.location.hash.replace('#', '')
    if (hash && tabItems && tabItems.length > 0) {
      const matchedTab = tabItems.find(
        tab => tab.replace(/\s+/g, '-').toLowerCase() === hash.toLowerCase()
      )
      if (matchedTab) {
        setSelectTab(matchedTab)
        setTimeout(() => {
          tabClick && tabClick(matchedTab)
        }, 100)
      }
    }
  }, [])

  useEffect(() => {
    if (!usePathBasedFilter || !filterBasePath) return

    const onPopState = () => {
      const stateFromPath = getStateFromGymsPath(
        window.location.pathname,
        tabItems
      )
      setSelectTab(stateFromPath)
      tabClick && tabClick(stateFromPath)
    }

    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [usePathBasedFilter, filterBasePath, tabItems, tabClick])

  const onTabClick = (tabName: string) => {
    if (usePathBasedFilter && filterBasePath) {
      const newUrl = tabName
        ? `${filterBasePath}/${formatStateForUrl(tabName)}`
        : filterBasePath

      window.history.pushState(null, '', newUrl)
      tabClick && tabClick(tabName)
      setSelectTab(tabName)
      return
    }

    const path = router.asPath.split('#')[0]

    if (tabName) {
      const formattedTabName = tabName.replace(/\s+/g, '-').toLowerCase()
      const newUrl = `${path}#${formattedTabName}`
      window.history.replaceState(null, '', newUrl)
    } else {
      window.history.replaceState(null, '', path)
    }

    tabClick && tabClick(tabName)
    setSelectTab(tabName)
  }

  return (
    <LocationTabWrapper template={template}>
      <LocationTabItem
        dangerouslySetInnerHTML={{ __html: 'ALL' }}
        className={selectTab === '' ? 'active' : ''}
        onClick={() => onTabClick('')}
      />
      {tabItems &&
        tabItems
          .filter(Boolean) // CMS can send '' (gym without state); ALL covers it
          .map((tab: string, idx) => {
            return (
              <LocationTabItem
                key={idx}
                className={
                  tab?.toLowerCase() === selectTab?.toLowerCase()
                    ? 'active'
                    : ''
                }
                onClick={() => onTabClick(tab)}
              >
                {tab}
              </LocationTabItem>
            )
          })}
    </LocationTabWrapper>
  )
}

export default LocationTab
